import React from "react";
import { Button, Tooltip, TooltipTrigger, TooltipContent } from "@heroui/react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";

interface ArtefactsPanelToggleProps {
  isVisible: boolean;
  onToggle: () => void;
  placement?: "bottom-end" | "bottom-start";
}

/**
 * Toggle button for showing/hiding the artefacts panel.
 * Shows appropriate icon and text based on panel visibility state.
 */
export const ArtefactsPanelToggle: React.FC<ArtefactsPanelToggleProps> = ({
  isVisible,
  onToggle,
  placement = "bottom-end",
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip>
      <TooltipTrigger>
        <Button
          aria-expanded={isVisible}
          aria-label={t("Toggle artefacts panel")}
          className="btn-brand-primary"
          data-testid="artefacts-toggle"
          size="sm"
          onPress={onToggle}
        >
          <Icon
            icon={isVisible ? "solar:sidebar-minimalistic-bold" : "solar:sidebar-code-bold"}
            width={16}
          />
          {isVisible ? "Hide" : "Show"} Content
        </Button>
      </TooltipTrigger>
      <TooltipContent placement={placement}>
        {isVisible ? "Hide Content Panel" : "Show Content Panel"}
      </TooltipContent>
    </Tooltip>
  );
};
